// extracted by mini-css-extract-plugin
export default {"base-accordion":"BaseAccordion-gQvOw__base-accordion"};